import { render, staticRenderFns } from "./orderGiveManage.vue?vue&type=template&id=3513d9fc&scoped=true"
import script from "./orderGiveManage.vue?vue&type=script&lang=js"
export * from "./orderGiveManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3513d9fc",
  null
  
)

export default component.exports